import React, {useState,useEffect} from 'react'
import Top from '@/components/home/top'
import Main from '@/components/home/main'
import './index.css'
import DeviceSummaryModal from '@/components/home/deviceSummaryModal'
import TableModal from '@/components/home/tjTableModal'
// import { use } from '_echarts@5.0.1@echarts'
function Home(props) {
    const [isPopup, setIsPopup] = useState('NoPopup')
    const [isFilterbg, setIsFilterbg] = useState('NoFilterbg')
    const [isShowAlertType, setisShowAlertType] = useState('classification')
    const [isStatisticsModal, setIsStatisticsModal] = useState(false)
    const initDom = () => {
        return <div className="scanboardWp" style={{width: '100%'}}>
                    <Top openAlertType={setAlertType} subClick={getPopupAndFilterbg} history={props.history}/>
                    <Main subClick={openStatisticsModal} isShowAlertType={isShowAlertType} />
                    <div className={isFilterbg}></div>
                    <div className={isPopup}><DeviceSummaryModal subClick={closeDeviceSummaryModal} isShowAlertType={isShowAlertType}/></div>
                    <div>
                        {isStatisticsModal ? <TableModal subClick={closeStatisticsModal} isShowAlertType={isShowAlertType}/> : null}
                    </div>
                </div>
    }
    // 打开物联网智能设备汇总模态框
    const getPopupAndFilterbg = (isPopup, isFilterbg) => {
        setIsPopup(isPopup)
        setIsFilterbg(isFilterbg)
    }
    // 设置设备的echarts类型切换
    const setAlertType = (params) => {
        setisShowAlertType(params)
    }
    // 关闭物联网智能设备汇总模态框
    const closeDeviceSummaryModal = (isPopup, isFilterbg) => {
        setIsPopup(isPopup)
        setIsFilterbg(isFilterbg)
    }
    // 打开工作量详情统计modal
    const openStatisticsModal = (isShow, isFilterbg) => {
        setIsStatisticsModal(isShow)
        setIsFilterbg(isFilterbg)
    }
    // 关闭工作量详情统计modal
    const closeStatisticsModal = (isShow, isFilterbg) => {
        setIsStatisticsModal(isShow)
        setIsFilterbg(isFilterbg)
    }
    useEffect(() => {
        initDom()
        return () => {
        }
    }, [isPopup, isShowAlertType, isStatisticsModal])
    return (
        initDom()
    )
}
export default Home